import { FC } from 'react';
import { Divider, Stack, StackProps } from '@chakra-ui/react';

const SidebarFooter: FC<StackProps> = (props) => (
  <>
    {/*
      the divider should take the full sidebar's width
      and ignore its inner paddings
    */}
    <Divider marginX="-space-24" width="auto" />

    <Stack
      alignItems="center"
      paddingBottom="space-8"
      paddingTop="space-24"
      paddingX="space-12"
      spacing="space-16"
      {...props}
    />
  </>
);

export default SidebarFooter;
